import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { GroupOrderBagButton } from '../GroupOrderBagButton/GroupOrderBagButton';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagCancelButton = (props: Props) => {
  const { isDisabled, onPress } = props;

  const { formatMessage } = useIntl();

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <GroupOrderBagButton
      icon="IconUnavailable"
      iconSize={18}
      accessibilityLabel={formatMessage(messages.label)}
      isDisabled={isDisabled}
      onPress={onPress}
    >
      <FormattedMessage {...messages.label} />
    </GroupOrderBagButton>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  label: {
    defaultMessage: 'Cancel group order',
    description: 'Bag | Group order | Cancel group order CTA',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  isDisabled: boolean;
  onPress: () => void;
};
